import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute, PublicRoute } from "./components/auth/AuthRoutes";
import { Toaster } from "./components/ui/sonner";

import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VendorRegistration from "./pages/VendorRegistration";
import VendorDashboard from "./pages/VendorDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import ApplicationList from "./pages/ApplicationList";
import ApplicationDetail from "./pages/ApplicationDetail";
import StoresManagement from "./pages/StoresManagement";
import AuthorizationsConfigPage from "./pages/AuthorizationsConfigPage";
import UserManagementPage from "./pages/UserManagementPage";
import { RequireElevated } from "./components/authorizations/RequireElevated";

import "./App.css";

const ADMIN_ROLES = [
  "indenter",
  "dealing_assistant",
  "assistant_registrar",
  "head_of_stores",
  "scrutiny_officer",
  "section_officer",
  "purchase_officer",
  "finance_officer",
  "approving_authority",
  "auditor",
  "dean",
  "director",
  "super_admin",
];

function AppRoutes() {
  return (
    <Routes>
      {/* Home stays reachable when logged in */}
      <Route path="/" element={<LandingPage />} />

      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <RegisterPage />
          </PublicRoute>
        }
      />
      <Route
        path="/admin/login"
        element={
          <PublicRoute>
            <AdminLoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPasswordPage />
          </PublicRoute>
        }
      />
      <Route
        path="/reset-password"
        element={
          <PublicRoute>
            <ResetPasswordPage />
          </PublicRoute>
        }
      />

      <Route
        path="/vendor/registration"
        element={
          <ProtectedRoute allowedRoles={["vendor"]}>
            <VendorRegistration />
          </ProtectedRoute>
        }
      />
      <Route
        path="/vendor/dashboard"
        element={
          <ProtectedRoute allowedRoles={["vendor"]}>
            <VendorDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/applications"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <ApplicationList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/applications/:id"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <ApplicationDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/stores"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <StoresManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/authorizations"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <RequireElevated>
              <AuthorizationsConfigPage />
            </RequireElevated>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <UserManagementPage />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
